import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  onClick(event) {
    if (this.isActionButton(event.target)) {
      return;
    }

    if (event.metaKey || event.ctrlKey) {
      window.open(this.element.dataset.url, '_blank');
    } else {
      const { turboFrame } = this.element.dataset;
      const { url } = this.element.dataset;

      if (turboFrame && turboFrame !== '_top') {
        // Only switch navigation behavior when a row explicitly opts into a Turbo Frame.
        // This keeps existing table rows (without a `data-turbo-frame`) unchanged.
        Turbo.visit(url, { frame: turboFrame });
        return;
      }

      window.location.href = url;
    }
  }

  isActionButton(element) {
    if (element.tagName === 'BUTTON' || element.tagName === 'A') {
      return true;
    }

    while (element.parentElement) {
      // eslint-disable-next-line no-param-reassign
      element = element.parentElement;
      if (element.tagName === 'BUTTON' || element.tagName === 'A') {
        return true;
      }
    }

    return false;
  }
}
